// extracted by mini-css-extract-plugin
export default {"notFoundPage":"notFoundPage_rw5C","tryAgain":"tryAgain_s6Op"};